import api from '../../common/services/api'
import { reset as formReset } from 'redux-form';
import {
    FETCH_START,
    FETCH_FAIL,
    USER_SIGNED_IN,
    USER_NOT_AUTHENTICATED,
    OPEN_SIGNIN_MODAL,
    OPEN_SIGNUP_MODAL,
    OPEN_PASSWORD_RECOVERY_MODAL,
    CLOSE_SIGNIN_MODAL,
    CLOSE_SIGNUP_MODAL,
    CLOSE_PASSWORD_RECOVERY_MODAL,
    PASSWORD_RECOVERY_FETCHED
} from './accountConstants'
import constants from '../../config/constants';
import Cookies from 'js-cookie';

export const signUp = form => {
    return async dispatch => {
        dispatch({ type: FETCH_START });

        try {
            const response = await api.post('/account/register', form);
            const { user, token } = response.data.data;

            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            user.keepConnect = form.remember || form.isFbLogin || false;

            localStorage.setItem('token', token);
            localStorage.setItem('bedukaUser', JSON.stringify(user));

            dispatch({ type: USER_SIGNED_IN, payload: user });
            dispatch(formReset('signUpForm'));
            return true
        } catch (e) {
            handleAuthError(dispatch, e);
            return false
        }
    }
};

export const signIn = form => {
    return async dispatch => {
        dispatch({ type: FETCH_START });

        try {
            const response = await api.post('/account/authenticate', form);
            
            const { user, token } = response.data.data;

            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            user.keepConnect = form.remember || form.isFbLogin || false;

            dispatch({ type: USER_SIGNED_IN, payload: user });
            dispatch(formReset('signInForm'));

            localStorage.setItem('token', token);
            localStorage.setItem('bedukaUser', JSON.stringify(user));

            return true
        } catch (e) {
            handleAuthError(dispatch, e);
            return false
        }
    }
};


export const setUser = user => {
    return dispatch => {
        dispatch({ type: USER_SIGNED_IN, payload: user });
    }
}

export const signOut = () => {
    return async dispatch => {
        localStorage.removeItem('bedukaUser');
        localStorage.removeItem('token');
        Cookies.remove('bedukaUser')
        Cookies.remove('ngToken')
        Cookies.remove('ngTokenTest')
        localStorage.removeItem(`${constants.BEDUKA_COM_TOKEN_NAME}`);
        localStorage.removeItem(`${constants.BEDUKA_COM_USER_NAME}`);

        window.location.href=`${constants.SIMULADO_V2_URL}`

        dispatch({ type: USER_NOT_AUTHENTICATED, payload: '' });

        
    }
}

export const passwordRecovery = form => {
    return async dispatch => {
        dispatch({ type: FETCH_START });

        try {
            await api.post('/account/requestpassword', form);
            
            dispatch(formReset('passwordRecoveryForm'));
            dispatch({
                type: PASSWORD_RECOVERY_FETCHED,
                payload: {
                    type: 'success',
                    message: 'Por favor, verique seu email com instruções para a recuperação da senha'
                }
            });
            return true
        } catch (e) {
            handleAuthError(dispatch, e);
            return false
        }
    }
};

export const openSignInModal = () => {
    return dispatch => {
        dispatch({ type: OPEN_SIGNIN_MODAL });
    }
}

export const openSignUpModal = () => {
    return dispatch => {
        dispatch({ type: OPEN_SIGNUP_MODAL });
    }
}

export const openPasswordRecoveryModal = () => {
    return dispatch => {
        dispatch({ type: OPEN_PASSWORD_RECOVERY_MODAL });
    }
}

export const closeSignInModal = () => {
    return dispatch => {
        dispatch({ type: CLOSE_SIGNIN_MODAL });
    }
}

export const closeSignUpModal = () => {
    return dispatch => {
        dispatch({ type: CLOSE_SIGNUP_MODAL });
    }
}
export const closePasswordRecoveryModal = () => {
    return dispatch => {
        dispatch({ type: CLOSE_PASSWORD_RECOVERY_MODAL });
    }
}

const handleAuthError = (dispatch, error) => {
    const errors = error && error.data ? error.data.errors : error;
    dispatch({ type: FETCH_FAIL });

    if (errors) {
        dispatch({ type: USER_NOT_AUTHENTICATED, payload: { type: 'alert', message: errors } })
    }
}
